<template>
  <div v-loading="loading" class="cs-student-speedup-course-history-list">
    <el-row :class="{ 'term-row': index > 0 }" v-for="(item, index) in courseRecords" v-bind:key="index">
      <el-col :span="24" :xs="24">
        <el-table ref="termCourses" :data="item.Courses" :header-row-class-name="'el-table-header'"
          :cell-class-name="cellStyle">
          <el-table-column prop="CourseFullName" :label="getCourseColTitle(item)"
            class-name="courses-history-colmun-width">
            <template slot-scope="scope">
              <span
                v-if="canOpenAttendanceDetail(scope.row)"
                class="course-name-link"
                @click="onOpenAttendanceDetail(scope.row, item)">
                {{ scope.row.CourseFullName }}
              </span>
              <span v-else>{{ scope.row.CourseFullName }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="courseType === GLOBAL.courseType.university && !USERMANAGER.isStudent" prop="CourseCategoryDescription" label="课程形式"
            class-name="courses-history-colmun-width">
            <template slot-scope="scope">
              <div>{{ scope.row.CourseCategoryDescription }}</div>
              <div v-if="scope.row.IsReviewCourse && scope.row.ReviewCourseStart && scope.row.ReviewCourseEnd">
                <span>{{ scope.row.ReviewCourseStart }}</span>至<span>{{ scope.row.ReviewCourseEnd }}</span>
              </div>
              <el-button v-if="enableEdit && item.IsCurrentTerm && scope.row.IsReviewCourse" type="text" size="medium"
                @click="onEditReviewCourseDate(scope.row)">
                编辑
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="CampusName" v-if="courseType === GLOBAL.courseType.vocationalTraining" label="校区"
            class-name="courses-history-colmun-width">
             <template slot-scope="scope">
              <div v-if="editingIndex == scope.row.Id && currentEditing == 'campus'">
                <el-select placeholder="请选择" v-model="editingCampus" size="medium" class="course-score-selector">
                  <el-option v-for="itemCampus in campusList" :key="itemCampus.Id" :label="itemCampus.Name" :value="itemCampus.Id">
                  </el-option>
                </el-select>
                <el-button type="text" size="medium" @click="onSaveSpeedupCourseCampus(scope.row)">
                  保存
                </el-button>
                <el-button type="text" size="medium" @click="onCancelSpeedupCourseCampus()">
                  取消
                </el-button>
              </div>
              <div v-else>
                <span>{{ scope.row.CampusName }}</span>
                <el-button v-if="enableEdit && item.IsCurrentTerm" type="text" size="medium"
                  @click="onEditSpeedupCourseCampus(scope.row)">
                  编辑
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="courseType !== GLOBAL.courseType.newStudentGuide" prop="TeacherName" label="速成老师"
            class-name="courses-history-colmun-width">
          </el-table-column>
          <el-table-column prop="ContractId" label="合同" class-name="courses-history-colmun-width">
            <template #default="{ row }">
              <span>{{ __findContractDesc(row.ContractId) }}</span>
              <el-button v-if="__findContractFiles(row.ContractId).length > 0" type="text" size="medium"
                :loading="row._downloadLoading" @click="downloadContractFile(row)">
                附件
              </el-button>
            </template>
          </el-table-column>
          <el-table-column v-if="[GLOBAL.courseType.english].contains(courseType)" prop="EnsureScore" label="所保成绩"
            class-name="courses-history-colmun-width">
          </el-table-column>
          <el-table-column v-if="courseType !== GLOBAL.courseType.newStudentGuide && canViewScore" prop="Score" label="期末成绩"
            fixed="right" :min-width="80">
            <template slot-scope="scope">

              <div v-show="editingIndex == scope.row.Id && currentEditing == 'score'">
                <el-select v-if="courseType === GLOBAL.courseType.university" placeholder="请选择" v-model="editingScore"
                  size="medium" class="course-score-selector">
                  <el-option v-for="item in scoreList" :key="item.Value" :label="item.Text" :value="item.Value">
                  </el-option>
                </el-select>
                <el-select v-if="courseType === GLOBAL.courseType.vocationalTraining" placeholder="请选择"
                  v-model="editingScore" size="medium" class="course-score-selector">
                  <el-option v-for="item in trainingScoreList" :key="item.Value" :label="item.Text" :value="item.Value">
                  </el-option>
                </el-select>
                <el-select v-if="courseType === GLOBAL.courseType.english" placeholder="请选择" v-model="editingScore"
                  size="medium" class="course-score-selector">
                  <el-option v-for="item in englishScoreList" :key="item.Value" :label="item.Text" :value="item.Value">
                  </el-option>
                </el-select>
                <el-button type="text" size="medium" @click="onSaveSpeedupCourseScore(scope.row)">
                  保存
                </el-button>
                <el-button type="text" size="medium" @click="onCancelSpeedupCourseScore()">
                  取消
                </el-button>
              </div>
              <div v-show="(editingIndex != scope.row.Id || currentEditing != 'score') && !scope.row.IsReviewCourse">
                <span v-if="!scope.row.Score" class="french-grey">未添加成绩</span>
                <span v-if="scope.row.Score">{{ scope.row.Score }}</span>
                <el-button v-if="enableEdit" type="text" size="medium" @click="onEditSpeedupCourseScore(scope.row)">
                  编辑
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="courseType === GLOBAL.courseType.vocationalTraining" prop="IsVideoFree" label="视频免费"
            fixed="right" :min-width="80">
            <template slot-scope="scope">
              <div v-if="editingIndex == scope.row.Id && currentEditing == 'IsVideoFree'">
                <el-select
                  v-if="[GLOBAL.courseType.university, GLOBAL.courseType.vocationalTraining].contains(courseType)"
                  placeholder="请选择" v-model="editingIsVideoFree" size="medium" class="course-score-selector">
                  <el-option :value="0" :label="'否'">
                    否
                  </el-option>
                  <el-option :value="1" :label="'是'">
                    是
                  </el-option>
                </el-select>
                <el-input size="mini" style="margin-top:10px;" v-model="editingComment" placeholder="请填写原因"></el-input>
                <el-button type="text" size="medium" @click="onSaveSpeedupCourseIsVideoFree(scope.row)">
                  保存
                </el-button>
                <el-button type="text" size="medium" @click="onCancelSpeedupCourseIsVideoFree()">
                  取消
                </el-button>
              </div>
              <div v-else>
                <span>{{ scope.row.IsVideoFreeText }}</span>
                <el-button v-if="enableEdit && item.IsCurrentTerm" type="text" size="medium"
                  @click="onEditSpeedupCourseIsVideoFree(scope.row)">
                  编辑
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="courseType === GLOBAL.courseType.university && !USERMANAGER.isStudent" prop="SupplementVideoType" label="视频机制/复习课"
            fixed="right" :min-width="150">
            <template slot-scope="scope">
              <div>
                <div v-if="scope.row.IsReviewCourse">
                  <div v-if="editingIndex == scope.row.Id && currentEditing == 'ReviewCourseActivation'">
                    <el-select placeholder="请选择" v-model="courseActivationIdList" size="medium" :multiple="true"
                      class="">
                      <el-option v-for="item in reviewCourseActivationList" :key="item.Id" :label="item.Name"
                        :value="item.Id">
                      </el-option>
                    </el-select>
                    <el-button type="text" size="medium" @click="onSaveReviewCourseActivation(scope.row)">
                      保存
                    </el-button>
                    <el-button type="text" size="medium" @click="onCancelReviewCourseActivation()">
                      取消
                    </el-button>
                  </div>
                  <div v-else>
                    <span class="cs-reviewCourseActivationText"
                      v-for="(item, index) in scope.row.ReviewCourseActivationTextList" :key="index">
                      {{ item }}
                    </span>
                    <el-button v-if="enableEdit && item.IsCurrentTerm" type="text" size="medium"
                      @click="onEditReviewCourseActivation(scope.row, item.TermId)">
                      编辑
                    </el-button>
                  </div>
                </div>
                <div v-else>
                  <div>{{ scope.row.SupplementVideoTypeText }}</div>
                  <div v-if="scope.row.SupplementVideoType == 0">开始周期: Week {{ scope.row.StartWeek }}</div>
                  <el-button v-if="enableEdit && item.IsCurrentTerm" type="text" size="medium"
                    @click="onEditSpeedupCourseSupplementVideoType(scope.row, item.TermId)">
                    编辑
                  </el-button>
                </div>
              </div>
            </template>
          </el-table-column> 
          <el-table-column v-if="courseType === GLOBAL.courseType.university && !USERMANAGER.isStudent" prop="SignInOnlineDisabled" label="线上签到禁用"
            fixed="right" :min-width="80">
            <template slot-scope="scope">
              <div v-if="editingIndex == scope.row.Id && currentEditing == 'SignInOnlineDisabled'">
                <el-checkbox v-model="editingSignInOnlineDisabled" size="medium" class="course-score-selector">禁用</el-checkbox>
                <el-button type="text" size="medium" @click="onSaveSpeedupCourseSignInOnlineDisabled(scope.row)">
                  保存
                </el-button>
                <el-button type="text" size="medium" @click="onCancelSpeedupCourseSignInOnlineDisabled()">
                  取消
                </el-button>
              </div>
              <div v-else>
                <span>{{ scope.row.SignInOnlineDisabled ? "是" : "否" }}</span>
                <el-button v-if="enableEdit && item.IsCurrentTerm" type="text" size="medium"
                  @click="onEditSpeedupCourseSignInOnlineDisabled(scope.row)">
                  编辑
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="courseType === GLOBAL.courseType.university && !USERMANAGER.isStudent" prop="IsAiCourseEnabled" label="启用AI课程"
            fixed="right" :min-width="80">
            <template slot-scope="scope">
              <div v-if="editingIndex == scope.row.Id && currentEditing == 'IsAiCourseEnabled'">
                <el-checkbox v-model="editingIsAiCourseEnabled" size="medium" class="course-score-selector">启用</el-checkbox>
                <el-button type="text" size="medium" @click="onSaveSpeedupCourseIsAiCourseEnabled(scope.row)">
                  保存
                </el-button>
                <el-button type="text" size="medium" @click="onCancelSpeedupCourseIsAiCourseEnabled()">
                  取消
                </el-button>
              </div>
              <div v-else>
                <span>{{ scope.row.IsAiCourseEnabled ? "是" : "否" }}</span>
                <el-button v-if="enableEdit && item.IsCurrentTerm" type="text" size="medium"
                  @click="onEditSpeedupCourseIsAiCourseEnabled(scope.row)">
                  编辑
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="[GLOBAL.courseType.english].contains(courseType)" prop="ScoreUrl" label="成绩图片"
            class-name="courses-history-colmun-width">
            <template slot-scope="scope">
              <div v-show="!!scope.row.ScoreUrl">
                <el-button type="text" size="medium" @click="checkScoreImage(scope.row.ScoreUrl)">
                  查看图片
                </el-button>
              </div>
              <div>
                <el-button type="text" size="medium" @click="uploadScore(scope.row)">
                  上传成绩图片
                </el-button>
              </div>
              <el-dialog center title="上传学生成绩图片" :show-close="true" :close-on-click-modal="false" width="700px"
                :visible.sync="scoreUploaderVisible" top="8vh">
                <blob-uploader @closeEditor="onCloseScoreUploader" @blobUploadError="onScoreUploadError"
                  @blobUploaded="onScoreUploaded" :type="3" :accepts="'.png,.jpg,.jpeg'"
                  :isVisible="scoreUploaderVisible"></blob-uploader>
              </el-dialog>
              <el-dialog center title="查看学生成绩图片" :show-close="true" :close-on-click-modal="false" width="700px"
                :visible.sync="scoreShowerVisible" top="8vh">
                <image-show v-on:closeEditor="onCloseScoreShower" :src="scoreShowSrc" :isVisible="scoreShowerVisible">
                </image-show>
              </el-dialog>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog title="编辑视频机制" :close-on-click-modal="false" :visible.sync="supplementVideoEditVisible" top="8vh"
      width="600px">
      <supplementVideoEdit :data="supplementVideoEditData" @success="onEditSpeedupCourseSupplementVideoSuccess">
      </supplementVideoEdit>
    </el-dialog>
    <el-dialog center title="编辑复习课起止时间" :close-on-click-modal="false" :visible.sync="reviewCourseDateEditVisible" top="8vh"
      width="600px">
      <reviewCourseDateEdit
        :data="reviewCourseDateEditData"
        @cancel="onCancelReviewCourseDate"
        @success="onSaveReviewCourseDateSuccess">
      </reviewCourseDateEdit>
    </el-dialog>
    <studentCourseAttendanceDetailDialog
      :visible.sync="attendanceDetailVisible"
      :studentId="studentId"
      :courseId="attendanceDetailCourseId"
      :termId="attendanceDetailTermId"
      :campusId="attendanceDetailCampusId"
      :courseName="attendanceDetailCourseName">
    </studentCourseAttendanceDetailDialog>
  </div>
</template>

<style lang="scss" scoped>
.courses-history-colmun-width {
  min-width: 120px;
}

.course-score-selector {
  height: 30px;
  line-height: 30px;
  width: 100px;
}

.cs-reviewCourseActivationText {
  display: block;
}

.cs-student-speedup-course-history-list {
  min-height: 48px;
}

.course-name-link {
  color: #409eff;
  cursor: pointer;
  user-select: text;
  -webkit-user-select: text;

  &:hover {
    color: #66b1ff;
    text-decoration: underline;
  }
}
</style>

<script>
import {
  saveStudentSpeedupCourseScore,
  saveStudentSpeedupCourseIsVideoFree,
  saveStudentSpeedupCourseSignInOnlineDisabled,
  saveStudentSpeedupCourseIsAiCourseEnabled,
  saveReviewCourseActivation,
  saveStudentSpeedupCourseCampus
} from "../../service/student.service";
import {
  saveCourseScoreFile,
  getBlobFileUrlById,
  downloadFileToBlob,
} from "../../service/blobStorage.service";
import {
  getScoreList,
  getReviewCourseActivationData,
  getCourseActivationNamesData
} from "../../service/common.service";
import blobUploader from "@/components/fileHandler/blobUploader";
import imageShow from "@/components/fileHandler/imageShow";
import { getEnglishScoreList, getNewStudentGuideScoreList, downloadFile } from "../../config/mUtils.js";
import supplementVideoEdit from "./supplementVideoEdit";
import reviewCourseDateEdit from "./reviewCourseDateEdit";
import studentCourseAttendanceDetailDialog from "./studentCourseAttendanceDetailDialog";

export default {
  props: {
    contractList: Array,
    studentName: String,
    studentId: Number,
    courseType: Number,
    courseRecords: Array,
    enableEdit: Boolean,
    campusList: Array,
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editingIndex: 0,
      editingScore: "",
      editingIsVideoFree: "",
      editingSignInOnlineDisabled: false,
      editingIsAiCourseEnabled: false,
      editingComment: "",
      editingCampus: null,
      currentEditing: "",
      scoreList: [],
      trainingScoreList: [],
      englishScoreList: [],
      newStudentGuideScoreList: [],
      scoreUploaderVisible: false,
      scoreUploaderContainer: "Receipt",
      scoreUploaderMode: "FrontEnd",
      scoreShowerVisible: false,
      scoreShowSrc: "",
      currentUploadScore: null,
      supplementVideoEditVisible: false,
      supplementVideoEditData: {},
      editRow: null,
      reviewCourseActivationData: {},
      reviewCourseActivationList: [],
      courseActivationIdList: [],
      editingReviewCourseRow: null,
      reviewCourseDateEditData: {
        id: 0,
        studentName: "",
        courseName: "",
        reviewCourseStart: "",
        reviewCourseEnd: ""
      },
      reviewCourseDateEditVisible: false,
      canViewScore: false,
      attendanceDetailVisible: false,
      attendanceDetailCourseId: 0,
      attendanceDetailTermId: 0,
      attendanceDetailCampusId: null,
      attendanceDetailCourseName: ""
    };
  },
  components: {
    blobUploader,
    imageShow,
    supplementVideoEdit,
    reviewCourseDateEdit,
    studentCourseAttendanceDetailDialog
  },
  created() {
    this.canViewScore = this.USERMANAGER.isAdmin || this.USERMANAGER.isTeacher || this.USERMANAGER.isAssistantTeacher 
      ||this.USERMANAGER.isAcademicDirector || this.USERMANAGER.isEducationalAssistant;
    this.initScoreList();
    this.englishScoreList = getEnglishScoreList();
    this.newStudentGuideScoreList = getNewStudentGuideScoreList();
  },
  methods: {
    initScoreList() {
      getScoreList().then(result => {
        if (!!result && result.success) {
          this.scoreList = result.data.filter(i => i.CourseType == this.GLOBAL.courseType.university);
          this.trainingScoreList = result.data.filter(i => i.CourseType == this.GLOBAL.courseType.vocationalTraining);
        }
      });
    },
    cellStyle(cell) {
      let cellClass = "";
      if ((cell.rowIndex + 1) % 2 == 1) {
        cellClass = "el-table-cell-single";
      } else {
        cellClass = "el-table-cell-double";
      }
      return cellClass;
    },
    getCourseColTitle(item) {
      if (item.CourseType == this.GLOBAL.courseType.vocationalTraining) {
        return item.CategoryName + " " + item.Term;
      } else if (item.CourseType == this.GLOBAL.courseType.english) {
        return item.CategoryName;
      } else if (item.CourseType == this.GLOBAL.courseType.newStudentGuide) {
        return item.CategoryName;
      } else {
        return item.Term;
      }
    },
    canOpenAttendanceDetail(row) {
      const isSupportedType =
        this.courseType === this.GLOBAL.courseType.university ||
        this.courseType === this.GLOBAL.courseType.vocationalTraining;
      return isSupportedType && !row.IsReviewCourse;
    },
    onOpenAttendanceDetail(row, termGroup) {
      const selection = window.getSelection && window.getSelection();
      if (selection && selection.toString()) {
        return;
      }
      this.attendanceDetailCourseId = row.CourseId;
      this.attendanceDetailTermId = termGroup.TermId;
      this.attendanceDetailCampusId = row.CampusId || null;
      this.attendanceDetailCourseName = row.CourseFullName || row.CourseName || "";
      this.attendanceDetailVisible = true;
    },
    onEditSpeedupCourseScore(row) {
      this.editingIndex = row.Id;
      this.editingScore = row.ScoreValue;
      this.currentEditing = "score";
    },
    onCancelSpeedupCourseScore() {
      this.editingIndex = 0;
      this.editingScore = "";
    },
    onSaveSpeedupCourseScore(row) {
      let desc = "";
      if ([this.GLOBAL.courseType.english].contains(row.CourseType)) {
        desc = this.editingScore;
      } else {
        let score = null;
        if (row.CourseType == this.GLOBAL.courseType.university) {
          score = this.scoreList.find(i => i.Value == this.editingScore);
        } else if (row.CourseType == this.GLOBAL.courseType.vocationalTraining) {
          score = this.trainingScoreList.find(i => i.Value == this.editingScore);
        }
        if (!!score) {
          desc = score.Text;
        }
      }

      this.$confirm(
        "您确定要将该学生课程" +
        row.CourseName +
        "的成绩修改为:" +
        desc +
        "?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          saveStudentSpeedupCourseScore(row.Id, null, null, this.editingScore).then(
            result => {
              if (!!result && result.success) {
                this.$message({
                  message: "成绩修改成功",
                  type: "success"
                });
                row.Score = desc;
                row.ScoreValue = this.editingScore;
                //this.initData();
                this.onCancelSpeedupCourseScore();
              } else {
                this.$message.error("保存失败。" + result.message);
              }
            }
          );
        })
        .catch(() => { });
    },
    onEditSpeedupCourseIsVideoFree(row) {
      this.editingIndex = row.Id;
      this.editingIsVideoFree = row.IsVideoFreeText;
      this.editingComment = "";
      this.currentEditing = "IsVideoFree";
    },
    onCancelSpeedupCourseIsVideoFree() {
      this.editingIndex = 0;
      this.editingIsVideoFree = "";
      this.editingComment = "";
      this.currentEditing = "";
    },
    onSaveSpeedupCourseIsVideoFree(row) {
      if (this.editingComment == "") {
        this.$message.error("保存失败, 原因不能为空");
        return;
      }
      let desc = this.editingIsVideoFree == 0 ? "否" : "是";
      this.$confirm(
        "您确定要将该学生课程" +
        row.CourseName +
        "的视频免费改为:" +
        desc +
        "?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          saveStudentSpeedupCourseIsVideoFree(row.Id, this.editingIsVideoFree, this.editingComment).then(
            result => {
              if (!!result && result.success) {
                this.$message({
                  message: "视频免费修改成功",
                  type: "success"
                });
                row.IsVideoFreeText = desc;
                row.IsVideoFree = this.editingIsVideoFree == 1;
                this.onCancelSpeedupCourseIsVideoFree();
              } else {
                this.$message.error("保存失败。" + result.message);
              }
            }
          );
        })
        .catch(() => { });
    },

    onEditSpeedupCourseSignInOnlineDisabled(row) {
      this.editingIndex = row.Id;
      this.editingSignInOnlineDisabled = row.SignInOnlineDisabled;
      this.currentEditing = "SignInOnlineDisabled";
    },
    onCancelSpeedupCourseSignInOnlineDisabled() {
      this.editingIndex = 0;
      this.editingSignInOnlineDisabled = false;
      this.currentEditing = "";
    },
    onSaveSpeedupCourseSignInOnlineDisabled(row) {
      // if (this.editingComment == "") {
      //   this.$message.error("保存失败, 原因不能为空");
      //   return;
      // }

      let desc = this.editingSignInOnlineDisabled ?  "是" : "否";
      this.$confirm(
        "您确定要将该学生课程" +
        row.CourseName +
        "的线上签到禁用改为:" +
        desc +
        "?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          saveStudentSpeedupCourseSignInOnlineDisabled(row.Id, this.editingSignInOnlineDisabled).then(
            result => {
              if (!!result && result.success) {
                this.$message({
                  message: "线上签到禁用修改成功",
                  type: "success"
                });
                row.SignInOnlineDisabled = this.editingSignInOnlineDisabled == 1;
                this.onCancelSpeedupCourseSignInOnlineDisabled();
              } else {
                this.$message.error("保存失败。" + result.message);
              }
            }
          );
        })
        .catch(() => { });
    },
    onEditSpeedupCourseIsAiCourseEnabled(row) {
      this.editingIndex = row.Id;
      this.editingIsAiCourseEnabled = row.IsAiCourseEnabled;
      this.currentEditing = "IsAiCourseEnabled";
    },
    onCancelSpeedupCourseIsAiCourseEnabled() {
      this.editingIndex = 0;
      this.editingIsAiCourseEnabled = false;
      this.currentEditing = "";
    },
    onSaveSpeedupCourseIsAiCourseEnabled(row) {
      let desc = this.editingIsAiCourseEnabled ? "是" : "否";
      this.$confirm(
        "您确定要将该学生课程" +
        row.CourseName +
        "的启用AI课程改为:" +
        desc +
        "?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          saveStudentSpeedupCourseIsAiCourseEnabled(row.Id, this.editingIsAiCourseEnabled).then(
            result => {
              if (!!result && result.success) {
                this.$message({
                  message: "启用AI课程修改成功",
                  type: "success"
                });
                row.IsAiCourseEnabled = !!this.editingIsAiCourseEnabled;
                this.onCancelSpeedupCourseIsAiCourseEnabled();
              } else {
                this.$message.error("保存失败。" + result.message);
              }
            }
          );
        })
        .catch(() => { });
    },
    onEditSpeedupCourseSupplementVideoType(row, termId) {
      this.editRow = row;
      this.supplementVideoEditData = {
        studentName: this.studentName,
        studentId: this.studentId,
        courseId: row.CourseId,
        courseName: row.CourseName,
        id: row.Id,
        week: row.StartWeek,
        supplementVideoType: row.SupplementVideoType,
        termId: termId,
        yearCourseType: row.YearCourseType,
        isYearCourseChange: row.IsYearCourseChange
      };

      this.supplementVideoEditVisible = true;
    },
    onEditSpeedupCourseSupplementVideoSuccess(data) {
      this.supplementVideoEditVisible = false;
      this.editRow.StartWeek = data.week;
      this.editRow.SupplementVideoType = data.supplementVideoType;
      this.editRow.SupplementVideoTypeText = data.supplementVideoTypeText;
    },
    onEditReviewCourseActivation(row) {
      this.editingIndex = row.Id;
      this.courseActivationIdList = row.ReviewCourseActivationIdList;
      let list = this.reviewCourseActivationData[row.CourseId];
      if (!!list && list.length > 0) {
        this.reviewCourseActivationList = list;//list.filter(i => i.CourseCategory == row.CourseCategory);
      } else {
        this.reviewCourseActivationList = [];
      }
      this.currentEditing = "ReviewCourseActivation";
    },
    onCancelReviewCourseActivation() {
      this.editingIndex = 0;
      this.editingScore = "";
    },
    onSaveReviewCourseActivation(row) {

      this.$confirm(
        "您确定要保存学生复习课节?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          saveReviewCourseActivation(row.Id, this.courseActivationIdList).then(
            result => {
              if (!!result && result.success) {
                this.$message({
                  message: "修改成功",
                  type: "success"
                });
                row.ReviewCourseActivationIdList = this.courseActivationIdList;
                row.ReviewCourseActivationTextList = this.courseActivationIdList.map(i => {
                  let item = this.reviewCourseActivationList.find(j => j.Id == i);
                  if (!!item) {
                    return item.Name;
                  }
                  return "";
                });
                this.onCancelReviewCourseActivation();
              } else {
                this.$message.error("保存失败。" + result.message);
              }
            }
          );
        })
        .catch(() => { });
    },
    onEditReviewCourseDate(row) {
      this.editingReviewCourseRow = row;
      this.reviewCourseDateEditData = {
        id: row.Id,
        studentName: this.studentName,
        courseName: row.CourseName,
        reviewCourseStart: row.ReviewCourseStart,
        reviewCourseEnd: row.ReviewCourseEnd
      };
      this.reviewCourseDateEditVisible = true;
    },
    onCancelReviewCourseDate() {
      this.editingReviewCourseRow = null;
      this.reviewCourseDateEditVisible = false;
    },
    onSaveReviewCourseDateSuccess() {
      this.onCancelReviewCourseDate();
      this.$emit("reload-course-records");
    },
    onEditSpeedupCourseCampus(row) {
      this.editingIndex = row.Id;
      this.editingCampus = row.CampusId;
      this.currentEditing = "campus";
    },
    onCancelSpeedupCourseCampus() {
      this.editingIndex = 0;
      this.editingCampus = "";
      this.currentEditing = "";
    },
    onSaveSpeedupCourseCampus(row) {
      
      let campus = this.campusList.find(i => i.Id === this.editingCampus);
      if (!campus){
        this.$message.error("未选择校区");
        return;
      }
      let campusName = campus.Name;

      this.$confirm(
        "您确定要将该学生课程" +
        row.CourseName +
        "的校区改为:" +
        campusName +
        "?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          saveStudentSpeedupCourseCampus(row.Id, this.editingCampus).then(
            result => {
              if (!!result && result.success) {
                this.$message({
                  message: "校区修改成功",
                  type: "success"
                });
                row.CampusName = campusName;
                row.CampusId = this.editingCampus;
                this.onCancelSpeedupCourseCampus();
              } else {
                this.$message.error("保存失败。" + result.message);
              }
            }
          );
        })
        .catch(() => { });
    },
    uploadScore(row) {
      this.currentUploadScore = row;
      this.scoreUploaderVisible = true;
    },
    onCloseScoreUploader() {
      this.closeScoreUploader();
    },
    onScoreUploadError() {

    },
    closeScoreUploader() {
      this.scoreUploaderVisible = false;
      this.currentUploadScore = null;
    },
    onScoreUploaded(data) {
      if (!!data) {
        data.fileId = this.currentUploadScore.FileId;
        saveCourseScoreFile(this.currentUploadScore.Id, data).then(
          result => {

            if (!!result && result.success) {
              // this.$message({
              //   message: "成绩图片上传成功",
              //   type: "success"
              // });
              this.currentUploadScore.FileId = result.data.FileId;
              this.currentUploadScore.ScoreUrl = result.data.Path;
            } else {
              this.$message.error("成绩图片上传失败");
            }
            this.closeScoreUploader();
          }
        ).catch(err => {
          this.closeScoreUploader();
        });
      } else {
        this.closeScoreUploader();
      }
    },
    checkScoreImage(src) {
      this.scoreShowSrc = src;
      this.scoreShowerVisible = true;
    },
    onCloseScoreShower() {
      this.scoreShowerVisible = false;
    },
    downloadContractFile(row) {
      let contractFiles = this.__findContractFiles(row.ContractId);
      if (contractFiles.length === 0) {
        this.$message.error("未能正确获取到文件数据。");
        return;
      }

      this.$set(row, "_downloadLoading", true);
      getBlobFileUrlById(contractFiles[0].FileStorageId)
        .then((result) => {
          if (!!result && result.success) {
            let { Url, FileName } = result.data;
            downloadFileToBlob(Url, 0).then((res) => {
              if (!!res && !!res.data)
                downloadFile({ data: res.data, filename: FileName });
              else this.$message.error("未能正确获取到文件数据。");

              this.$set(row, "_downloadLoading", false);
            }).catch(() => {
              this.$set(row, "_downloadLoading", false);
            });
          } else {
            if (!!result.message) {
              this.$message.error(result.message);
            }

            this.$set(row, "_downloadLoading", false);
          }
        })
        .catch(() => {
          this.$set(row, "_downloadLoading", false);
        });
    },
    __findContractDesc(contractId) {
      let contract = this.contractList.find(item => item.Id === contractId);
      return !!contract ? contract.Description : String.empty;
    },
    __findContractFiles(contractId) {
      let contract = this.contractList.find(item => item.Id === contractId);
      if (!contract)
        return [];

      return !!contract.Files ? contract.Files : [];
    }
  },
  watch: {
    courseRecords: function () {
      if (this.enableEdit && this.courseType === this.GLOBAL.courseType.university) {
        let currentTermData = this.courseRecords.find(i => !!i.IsCurrentTerm && i.CourseType === this.GLOBAL.courseType.university);
        if (!!currentTermData) {
          let courseIdList = currentTermData.Courses.map(i => i.CourseId);
          getCourseActivationNamesData(courseIdList).then(result => {
            if (result && result.success) {
              this.reviewCourseActivationData = result.data;
            }
          });
        }
      }
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/studentProfile/studentSpeedupCourseHistoryList.vue